// src/constants/products.js
export const products = [
  {
    id: 1,
    name: 'Classic Logo T-Shirt',
    price: 29.99,
    description: 'Premium cotton t-shirt featuring the Sonny Souf logo',
    image: '/thumbnail_SOUF final BW.png',
    category: 'Apparel',
    status: 'Pre-order',
    variants: [
      { size: 'S', inStock: true },
      { size: 'M', inStock: true },
      { size: 'L', inStock: true },
      { size: 'XL', inStock: true }
    ]
  },
  {
    id: 2,
    name: 'Logo Hoodie',
    price: 49.99,
    description: 'Comfortable hoodie with embroidered Sonny Souf logo',
    image: '/thumbnail_SOUF final BW.png',
    category: 'Apparel',
    status: 'Pre-order',
    variants: [
      { size: 'S', inStock: true },
      { size: 'M', inStock: true },
      { size: 'L', inStock: true },
      { size: 'XL', inStock: true }
    ]
  },
  {
    id: 3,
    name: 'Snapback Cap',
    price: 24.99,
    description: 'Adjustable snapback cap with embroidered logo',
    image: '/thumbnail_SOUF final BW.png',
    category: 'Accessories',
    status: 'Pre-order',
    variants: [
      { size: 'One Size', inStock: true }
    ]
  }
];